import React from 'react'

import { LOCALE_OPTIONS } from '@makyoapp/makyo-common'
import { SelectDropdown, SelectDropdownProps } from '@makyoapp/makyo-ui'

export interface LocaleDdProps
  extends Omit<SelectDropdownProps<unknown>, 'options' | 'optionLabel' | 'value' | 'onChange'> {
  id: string
  value: string
  onChange: (next: string) => void
}
export function LocaleDd({ id, value, onChange, ...props }: LocaleDdProps) {
  return (
    <SelectDropdown
      id={id}
      withSearch={true}
      enableAutoScroll={true}
      value={LOCALE_OPTIONS.find((o) => o.value === value) || LOCALE_OPTIONS[0]}
      onChange={(opt) => {
        onChange(opt.value)
      }}
      optionLabel={(opt) => opt.label}
      options={LOCALE_OPTIONS}
      {...props}
    />
  )
}
